import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Pagination from 'react-js-pagination'
import classnames from 'classnames'
import { Button } from 'react-bootstrap';
import { Text, Label } from '@leverege/ui-elements'

import { ScriptActions, BreadcrumbActions, NotifyActions, Constants } from '~/actions'

import { List, Screen, TextInput, LabelGroup, Loading } from '~/views'
import PaginationSearch from '../utils/PaginationSearch'
import ScriptItem from './ScriptItem'

import style from './style.css'

class ScriptsScreen extends React.Component {

  static propTypes = {
    project : PropTypes.object
  }

  constructor( props, context ) {
    super( props, context )
    this.pager = new PaginationSearch( this, 'scripts', ( props, opts ) => {
      this.props.dispatch( ScriptActions.list( this.props.match.params.projectId, opts ) )
    } )
    this.state = { 
      selectId : null, 
      start : this.pager.getStartFrom( props ), 
      search : this.pager.getSearchFrom( props ) 
    }
  }

  componentDidMount() {
    this.pager.loadPage( this.props )
    this.props.dispatch( BreadcrumbActions.setBreadcrumbs( [ { name : 'scripts' } ] ) )
  }

  componentWillReceiveProps( next ) {
    this.pager.loadIfNeeded( next )
  }

  onCreateScript = () => {
    const { params } = this.props.match
    if ( params && params.projectId ) {
      this.props.dispatch( ScriptActions.create(
        params.projectId,
        {
          name : 'My Script',
        } 
      ) )
    }
  }

  onEvent = ( evt, item ) => {
    const { match, history, dispatch } = this.props
    const { params } = match
    switch ( evt ) {
      case ScriptItem.REMOVE_EVENT:
        dispatch( ScriptActions.delete( params.projectId, item ) )
        break
      case ScriptItem.SELECTED:
        if ( item && item.id ) {
          history.push( `/project/${match.params.projectId}/script/${item.id}` )
        }
        break
    }
  }

  onScriptChange = ( { path, target, value } ) => {
    console.log( path, target, value )
    
  }

  onScriptError = ( path, value, err ) => {
    this.props.dispatch( NotifyActions.error( err.message, value, path ) )
  }

  render() {
    const { selectId, search, start } = this.state
    const { scripts, projects, match } = this.props
    const { params } = match
    const page = this.pager.getPage()
    const total = this.pager.getTotal()
    const perPage = this.pager.getPerPage()
    const projectId = params && params.projectId

    const isSelected = ( item ) => {
      return selectId === ( item && item.id )
    }
    const loading = scripts.status == Constants.STATUS_LOADING
    const items = scripts.projectId == projectId ? this.pager.getPageItems() : []

    let selectItem = null
    items.forEach( ( item ) => {
      if ( selectId === item.id ) selectItem = item
    } )

    const left = (
      <div className={style.left}>
        <List className={classnames( style.list, style.splitLeft )}
          onEvent={this.onEvent} 
          isSelected={isSelected}
          noItemsView={loading ? null : null /* TODO: put something here */}
          items={items}
          itemView={ScriptItem}
          itemProps={{ hideNavButtons : false }} />
        <div className={style.pagination}>
          <Pagination
            innerClass={classnames( 'pagination', style.innerPagination )}
            activePage={page}
            itemsCountPerPage={perPage}
            totalItemsCount={total}
            pageRangeDisplayed={5}
            onChange={this.pager.onPageChange} />
        </div>
        <Loading show={loading} message="Loading..." />
      </div>
    )

    return (
      <Screen className={style.screen}>
        <Screen.Header className={style.header}>
          <Text variant="screenTitle">Scripts</Text>
          <div className={style.flexRight} style={{ display : 'inline-box', whiteSpace : 'nowrap' }}>
            <LabelGroup style={{ display : 'inline-flex', marginRight : 20 }}>
              <Label><i className="fa fa-search" /></Label>
              <TextInput value={search}
                hint="search" 
                changeOnBlur={false}
                changeOnReturn
                onChange={this.pager.onSearchChange} />
            </LabelGroup>
            <Button bsStyle="primary"
              className="add-button" 
              onClick={this.onCreateScript}> 
              <i className="fa fa-fw fa-circle-plus fa-lg" /> New Script
            </Button>
          </div>
        </Screen.Header>
        <Screen.Content>
          {left}
        </Screen.Content>
      </Screen>
    )
  }
}

export default connect(
  state => ( {
    scripts : state.scripts,
    projects : state.projects
  } )
)( ScriptsScreen )
